// frontend_react/src/services/calendarApi.js

import api, {
  buildActivityScopeHeaders,
  buildCompanyScopeHeaders,
} from "./api";


const buildEventScopeHeaders = ({
  companyUuid,
  activityUuid,
} = {}) => ({
  ...buildCompanyScopeHeaders(companyUuid),
  ...buildActivityScopeHeaders(activityUuid),
});

export const exportIcs = ({ companyUuid, activityUuid } = {}) =>
  api.get("/calendar/calendar/events/export", {
    responseType: "blob",
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const importIcs = (
  file,
  { companyUuid, activityUuid } = {},
) =>
  api.post("/calendar/calendar/events/import", file, {
    headers: {
      "Content-Type": "text/calendar",
      ...buildEventScopeHeaders({
        companyUuid,
        activityUuid,
      }),
    },
  });

export const fetchEvents = (
  start,
  end,
  { companyUuid, activityUuid } = {},
) =>
  api.get("/calendar/events", {
    params: { start, end },
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const getCalendarEvents = ({
  companyUuid,
  activityUuid,
} = {}) =>
  api.get("/calendar/events", {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const fetchEventById = (
  uuid,
  { companyUuid, activityUuid } = {},
) =>
  api.get(`/calendar/events/${uuid}`, {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const fetchEventRegistrations = (
  eventUuid,
  { companyUuid, activityUuid } = {},
) =>
  api.get(`/calendar/events/${eventUuid}/registrations`, {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const createEvent = (
  eventData,
  { companyUuid, activityUuid } = {},
) =>
  api.post("/calendar/events", eventData, {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const updateEvent = (
  uuid,
  eventData,
  { companyUuid, activityUuid } = {},
) =>
  api.put(`/calendar/events/${uuid}`, eventData, {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const deleteEvent = (
  uuid,
  { companyUuid, activityUuid } = {},
) =>
  api.delete(`/calendar/events/${uuid}`, {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

// Legacy routes encore utilisées par MyCalendar.jsx
export const createLegacyEvent = (
  eventData,
  { companyUuid, activityUuid } = {},
) =>
  api.post("/events", eventData, {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const updateLegacyEvent = (
  uuid,
  eventData,
  { companyUuid, activityUuid } = {},
) =>
  api.put(`/events/${uuid}`, eventData, {
    headers: buildEventScopeHeaders({
      companyUuid,
      activityUuid,
    }),
  });

export const registerToPublicEvent = (eventUuid, payload, { companyUuid } = {}) =>
  api.post(`/crm/public/events/${eventUuid}/register`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const getPublicEventIcsUrl = (eventUuid, companyUuid = null) => {
  const query = companyUuid ? `?company_uuid=${encodeURIComponent(companyUuid)}` : "";
  return `/api/crm/public/events/${eventUuid}/ics${query}`;
};